/** @format */
import React from 'react';
import { Grid } from '@mui/material';
import clsx from 'clsx';
import { useStyles } from './style';
import { Icons } from 'components';

export default function LabelLine({
  infoType,
  label = '',
  infoText = '',
  required = false,
  justify,
}) {
  /// success , warning, error, info
  const classes = useStyles({ infoType });

  return (
    <Grid container justifyContent={justify ?? 'space-between'} style={{ width: '100%' }} spacing={2}>
      <Grid style={{ padding: '8px' }}>
        {required && <span className={classes.asterisk}>* &nbsp;</span>}
        {label}
      </Grid>
      <Grid item>
        <Grid container alignItems="center" className={clsx(classes.inputStatus)}>
          {infoType === 'success' ? <span className={classes.inputStatusIcon} ><Icons icon='Accept' color='#ccc' size='20' /></span> : null}
          {infoType === 'error' ? <span className={classes.inputStatusIcon} ><Icons icon='CloseCircle' color='#ccc' size='20' /> </span> : null}
          {infoType === 'warning' ? <span className={classes.inputStatusIcon} ><Icons icon='Warning' color='#ccc' size='20' /></span> : null}
          {infoType === 'info' ? <span className={classes.inputStatusIcon} ><Icons icon='Info' color='#667585' size='17' /> </span> : null
          }
          <div>{infoText}</div>
        </Grid >
      </Grid >
    </Grid >
  );
}
